export const IaptCarryOutIaptAssessment = "IaptCarryOutIaptAssessment";
export const IaptCarryOutPhq9Assessment = "IaptCarryOutPhq9Assessment";
export const IaptCarryOutGad7Assessment = "IaptCarryOutGad7Assessment";
export const IaptCarryOutWsasAssessment = "IaptCarryOutWsasAssessment";
